"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resizeImage = exports.decodeBase64 = exports.base64ToArray = void 0;
var resizeBase64 = require('resize-base64');
var sizeOf = require('buffer-image-size');
var atob = require('atob');
function base64ToArray(imageBase64) {
    var imageURIarray = imageBase64.split(',');
    if (imageURIarray.length === 1) {
        imageURIarray.push(imageBase64);
        imageURIarray[0] = 'base64';
    }
    if (imageURIarray.length !== 2) {
        throw new Error('Base64 failed');
    }
    if (imageURIarray[0].indexOf('base64') === -1) {
        throw new Error('Header Base64 failed');
    }
    var base64 = imageURIarray[1];
    var raw = atob(base64);
    var array = new Uint8Array(new ArrayBuffer(raw.length));
    for (var i = 0; i < raw.length; i++) {
        array[i] = raw.charCodeAt(i);
    }
    return new Int8Array(array);
}
exports.base64ToArray = base64ToArray;
function decodeBase64(imageBase64) {
    var imageURIarray = imageBase64.split(',');
    if (imageURIarray.length === 1) {
        imageURIarray.push(imageBase64);
        imageURIarray[0] = 'base64';
    }
    if (imageURIarray.length !== 2) {
        throw new Error('Base64 failed');
    }
    if (imageURIarray[0].indexOf('base64') === -1) {
        throw new Error('Header Base64 failed');
    }
    var base64 = imageURIarray[1];
    var raw = atob(base64);
    var array = new Uint8Array(new ArrayBuffer(raw.length));
    for (var i = 0; i < raw.length; i++) {
        array[i] = raw.charCodeAt(i);
    }
    var dim = sizeOf(Buffer.from(array));
    return __assign({ image: array.slice() }, dim);
}
exports.decodeBase64 = decodeBase64;
function px(l, w, h) {
    return l / (w * h);
}
function newSize(l, pl, rate) {
    var w = Math.sqrt((l * rate) / pl);
    return {
        width: w,
        height: w / rate,
    };
}
/** @description Resize image.
 * @param {string} imageBase64 Base64 string.
 * @param {number} maxImageSize Max size.
 * @param {number} minImageSize Min size.
 * @return {Promise<string>} Base64.
 */
function resizeImage(imageBase64, maxImageSize, minImageSize) {
    return __awaiter(this, void 0, void 0, function () {
        var imageContainer, length, rate, pl, size, base64, c, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    imageContainer = decodeBase64(imageBase64);
                    length = imageContainer.image.length;
                    rate = imageContainer.width / imageContainer.height;
                    pl = px(length, imageContainer.width, imageContainer.height);
                    size = newSize(maxImageSize, pl, rate);
                    base64 = imageBase64;
                    _a.label = 1;
                case 1:
                    if (!(length > maxImageSize || length < minImageSize)) return [3 /*break*/, 3];
                    return [4 /*yield*/, resizeBase64(base64, size.width, size.height)];
                case 2:
                    base64 = _a.sent();
                    c = decodeBase64(base64);
                    length = c.image.length;
                    imageBase64 = base64;
                    pl = px(length, size.width, size.height);
                    size = newSize(maxImageSize, pl, rate);
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, imageBase64];
                case 4:
                    e_1 = _a.sent();
                    // console.log(e);
                    return [2 /*return*/, ''];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.resizeImage = resizeImage;
